import { Sparkles } from "lucide-react";
import { PodPreview } from "@/components/PodPreview";

const Row = ({ label, children }) => (
  <div>
    <p className="font-mono text-xs uppercase tracking-widest text-neutral-400 mb-3">{label}</p>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

const slug = (v) => v.replace(/\s+/g, "-").replace(/[()]/g, "").toLowerCase();
const btn = (active) => `px-4 h-11 font-mono text-sm border transition-colors ${active ? "bg-white text-black border-white" : "border-white/15 text-neutral-300 hover:border-white/50 hover:text-white"}`;

export const summaryOf = (pod, value) => {
  const pl = pod.placements.find((p) => p.key === value.placement);
  return `${value.color} · ${value.size} · ABS logo ${pl?.label.toLowerCase() || ""}`.trim();
};

export const CustomizePanel = ({ pod, value, onChange }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  const colorHex = pod.colors.find((c) => c.name === value.color)?.hex || "#333";
  return (
    <section data-testid="customize-section" className="mt-8 border border-white/10 bg-[#121215] p-5 sm:p-6">
      <p className="flex items-center gap-2 font-display uppercase font-black text-xl"><Sparkles className="w-5 h-5 text-[#FF3B30]" />Customize</p>
      <p className="font-mono text-[11px] text-neutral-500 mt-1 mb-6">Made to order with the official ABS logo. Pick your presets — no uploads needed.</p>
      <div className="grid grid-cols-1 sm:grid-cols-[180px_1fr] gap-6">
        <PodPreview kind={pod.kind} color={colorHex} placement={value.placement} />
        <div className="space-y-6">
          <Row label={<>Color: <span className="text-white">{value.color}</span></>}>
            {pod.colors.map((c) => (
              <button key={c.name} data-testid={`customize-color-${slug(c.name)}`} onClick={() => set({ color: c.name })} title={c.name}
                className={`w-11 h-11 border-2 transition-transform hover:scale-105 ${value.color === c.name ? "border-[#FF3B30]" : "border-white/20"}`} style={{ background: c.hex }} />
            ))}
          </Row>
          {pod.sizes.length > 1 && (
            <Row label={<>Size: <span className="text-white">{value.size}</span></>}>
              {pod.sizes.map((s) => <button key={s} data-testid={`customize-size-${slug(s)}`} onClick={() => set({ size: s })} className={`min-w-12 ${btn(value.size === s)}`}>{s}</button>)}
            </Row>
          )}
          <Row label={<>Logo placement: <span className="text-white">{pod.placements.find((p) => p.key === value.placement)?.label}</span></>}>
            {pod.placements.map((p) => <button key={p.key} data-testid={`customize-placement-${p.key}`} onClick={() => set({ placement: p.key })} className={btn(value.placement === p.key)}>{p.label}</button>)}
          </Row>
          <p data-testid="customize-summary" className="font-mono text-xs text-neutral-300 border-l-2 border-[#FF3B30] pl-3">
            Your build: {summaryOf(pod, value)}
          </p>
        </div>
      </div>
    </section>
  );
};
